/** Textos da seção Manutenções agendadas (consulta). */

export const MANUTENCOES_AGENDADAS_NAV_LABEL = 'Manutenções agendadas';

export const MANUTENCOES_AGENDADAS_SECTION_TITLE = 'Manutenções agendadas';
export const MANUTENCOES_AGENDADAS_SECTION_SUBTITLE =
  'Consulte no calendário as manutenções que você registrou ao agendar a partir de um WhatsApp recebido. Somente leitura.';

export const MANUTENCOES_AGENDADAS_LOADING = 'Carregando...';

export const MANUTENCOES_AGENDADAS_EMPTY =
  'Nenhuma manutenção agendada ainda. Quando você registrar data e valor ao agendar a partir de um WhatsApp recebido, ela aparecerá aqui.';

export const MANUTENCOES_AGENDADAS_CAL_TITLE = 'Calendário de manutenções';
export const MANUTENCOES_AGENDADAS_CAL_PREV_MONTH = 'Mês anterior';
export const MANUTENCOES_AGENDADAS_CAL_NEXT_MONTH = 'Próximo mês';
export const MANUTENCOES_AGENDADAS_CAL_CLEAR_DAY = 'Limpar seleção do dia';

export const MANUTENCOES_AGENDADAS_CAL_LEGEND_TITLE = 'Legenda';
export const MANUTENCOES_AGENDADAS_CAL_LEGEND_COUNT =
  'Número de manutenções com data de agendamento naquele dia.';

export const MANUTENCOES_AGENDADAS_HINT_SELECT_DAY =
  'Toque em um dia destacado para ver os detalhes abaixo.';

export const MANUTENCOES_AGENDADAS_DAY_EMPTY =
  'Nenhum agendamento neste dia.';

export const MANUTENCOES_AGENDADAS_LABEL_SCHEDULED_FOR = 'Agendada para:';
export const MANUTENCOES_AGENDADAS_LABEL_CLIENT = 'Cliente';
export const MANUTENCOES_AGENDADAS_LABEL_VALUE = 'Valor cobrado';
